exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.number__select input[data-v-6bf021d3] {\n  max-width: 65px;\n}\n.form-control-xs[type=number][data-v-6bf021d3] {\n  width: 65px;\n}\n.food__edit__header[data-v-6bf021d3] {\n  margin: 10px 0;\n}\n.black[data-v-6bf021d3] {\n  color: #000;\n}\n.food_product_drag_icon[data-v-6bf021d3]:hover {\n  cursor: grab;\n}\n", ""]);

// exports
